import { useMemo } from "react";
import {
  type ImageGalleryComponentProps,
  useImageGallery as useCoreImageGallery,
} from "@b2bportal/core-hotels";
import { useI18nContext } from "@hopper-b2b/i18n";

export const useImageGallery = ({
  name,
  media,
}: ImageGalleryComponentProps) => {
  const { t } = useI18nContext();

  const { context, text } = useCoreImageGallery({ name, media });

  return useMemo(() => {
    return {
      context,
      text: {
        ...text,
        imageButton: t("core-hotels.image.showAllImages", {
          count: context.images.length,
        }),
      },
    };
  }, [context, text, t]);
};
